<ng-template #content_label_variable_config let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.qr_label_gen">
        <div class="side_popup_header">
            <span>{{localService.languageContent.qr_label_gen.variable_header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="margin: 10px;padding: 10px;height: calc(100vh - 130px);" *ngIf="item">
        <div class="row">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.title" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" [(ngModel)]="item.v3" id="{{elementIds.title}}"
                        title="{{localService.languageContent.qr_label_gen.title}}"
                        placeholder="{{localService.languageContent.qr_label_gen.title}}" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.type" [IsMandatory]="true" />
                </div>
                <div>
                    <ngx-select [items]="variableTypes" [optionValueField]="'key'" [optionTextField]="'value'"
                        placeholder="{{localService.languageContent.qr_label_gen.type}}" [(ngModel)]="item.v2"
                        [noAutoComplete]="true" [disabled]="item.key.length > 5" id="{{elementIds.type}}"
                        (select)="onSelectType()">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && [QrLabelVariableType.FixedLabel.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.disp_text" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" [(ngModel)]="item.v4" id="{{elementIds.disp_text}}"
                        title="{{localService.languageContent.qr_label_gen.disp_text}}"
                        placeholder="{{localService.languageContent.qr_label_gen.disp_text}}" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && [QrLabelVariableType.DynamicValue.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.value_from" [IsMandatory]="true" />
                </div>
                <div>
                    <ngx-select [items]="dynamicValuesFrom" [optionValueField]="'key'" [optionTextField]="'value'"
                        placeholder="{{localService.languageContent.qr_label_gen.value_from}}" [(ngModel)]="item.v5"
                        [noAutoComplete]="false" [allowClear]="true" id="{{elementIds.value_from}}">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && [QrLabelVariableType.DynamicValue.toString()].includes(item.v2) && item.v5 && item.v5 == '9'">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.custom_field" [IsMandatory]="true" />
                </div>
                <div>
                    <ngx-select [items]="customFields" [optionValueField]="'key'" [optionTextField]="'value'"
                        placeholder="{{localService.languageContent.qr_label_gen.custom_field}}" [(ngModel)]="item.v15"
                        [noAutoComplete]="false" [allowClear]="true" id="{{elementIds.custom_field}}">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && ![QrLabelVariableType.BarCode.toString(),QrLabelVariableType.QrCode.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.language" [IsMandatory]="true" />
                </div>
                <div>
                    <ngx-select [items]="fontOptions" [optionValueField]="'key'" [optionTextField]="'s_value'"
                        placeholder="{{localService.languageContent.qr_label_gen.language}}" [(ngModel)]="item.v6"
                        [noAutoComplete]="false" [allowClear]="true" id="{{elementIds.language}}"
                        (remove)="onRemoveLanguage()" (select)="onSelectLanguage()">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="fontNames.length > 0 &&item.v2 && ![QrLabelVariableType.BarCode.toString(),QrLabelVariableType.QrCode.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.font" [IsMandatory]="true" />
                </div>
                <div>
                    <ngx-select [items]="fontNames" [optionValueField]="'key'" [optionTextField]="'value'"
                        placeholder="{{localService.languageContent.qr_label_gen.font}}" [(ngModel)]="item.v7"
                        [noAutoComplete]="true" [disabled]="fontNames.length == 1" [allowClear]="false"
                        id="{{elementIds.font}}">
                    </ngx-select>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;" *ngIf="item.v2">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.size" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.size}}"
                        [(ngModel)]="item.v8" style="width:100%;text-align: left;"
                        placeholder="*{{localService.languageContent.qr_label_gen.size}}"
                        title="{{localService.languageContent.qr_label_gen.size}}" [ngClass]="item.v8 ? 'en' : ''" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;" *ngIf="item.v2">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.x_pos" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.x_pos}}"
                        [(ngModel)]="item.v9" style="width:100%;text-align: left;"
                        placeholder="*{{localService.languageContent.qr_label_gen.x_pos}}"
                        title="{{localService.languageContent.qr_label_gen.x_pos}}" [ngClass]="item.v9 ? 'en' : ''" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;" *ngIf="item.v2">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.y_pos" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.y_pos}}"
                        [(ngModel)]="item.v10" style="width:100%;text-align: left;"
                        placeholder="*{{localService.languageContent.qr_label_gen.y_pos}}"
                        title="{{localService.languageContent.qr_label_gen.y_pos}}" [ngClass]="item.v10 ? 'en' : ''" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && [QrLabelVariableType.BarCode.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.bar_scale" [IsMandatory]="false" />
                </div>
                <div>
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfigWithoutDecimal)"
                        id="{{elementIds.bar_scale}}" [(ngModel)]="item.v13" style="width:100%;text-align: left;"
                        placeholder="*{{localService.languageContent.qr_label_gen.bar_scale}}"
                        title="{{localService.languageContent.qr_label_gen.bar_scale}}"
                        [ngClass]="item.v13 ? 'en' : ''" />
                </div>
            </div>
        </div>
        <div
            *ngIf="item.v2 && ![QrLabelVariableType.BarCode.toString(),QrLabelVariableType.QrCode.toString(),QrLabelVariableType.CurrencySymbol.toString()].includes(item.v2)">
            <div class="row" style="margin-top: 10px;">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.span_width"
                            [IsMandatory]="false" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.span_width}}"
                            [(ngModel)]="item.v14" style="width:100%;text-align: left;"
                            placeholder="*{{localService.languageContent.qr_label_gen.span_width}}"
                            title="{{localService.languageContent.qr_label_gen.span_width}}"
                            [ngClass]="item.v14 ? 'en' : ''" />
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col-12">
                    <label style="font-weight: normal;font-weight: normal;margin-left: 15px;">
                        <input type="checkbox" [(ngModel)]="isWrap" />
                        <span>{{localService.languageContent.qr_label_gen.wrap_text}}</span>
                    </label>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col-12">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.span_height"
                            [IsMandatory]="false" />
                    </div>
                    <div>
                        <input autocomplete="off" type="number" class="number"
                            (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.span_height}}"
                            [(ngModel)]="item.v17" style="width:100%;text-align: left;"
                            placeholder="*{{localService.languageContent.qr_label_gen.span_height}}"
                            title="{{localService.languageContent.qr_label_gen.span_height}}"
                            [ngClass]="item.v17 ? 'en' : ''" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && ![QrLabelVariableType.BarCode.toString(),QrLabelVariableType.QrCode.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.rot_pos" [IsMandatory]="false" />
                </div>
                <div>
                    <input autocomplete="off" type="number" class="number"
                        (keypress)="localService.isNumberOnly($event,numericConfigIncludeNegative)"
                        id="{{elementIds.rot_pos}}" [(ngModel)]="item.v12" style="width:100%;text-align: left;"
                        placeholder="*{{localService.languageContent.qr_label_gen.rot_pos}}"
                        title="{{localService.languageContent.qr_label_gen.rot_pos}}"
                        [ngClass]="item.v12 ? 'en' : ''" />
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 10px;"
            *ngIf="item.v2 && ![QrLabelVariableType.FixedLabel.toString(),QrLabelVariableType.CurrencySymbol.toString()].includes(item.v2)">
            <div class="col-12">
                <div>
                    <app-label [Text]="localService.languageContent.qr_label_gen.sample_text" [IsMandatory]="true" />
                </div>
                <div>
                    <input autocomplete="off" type="text" [(ngModel)]="item.v11" id="{{elementIds.sample_text}}"
                        title="{{localService.languageContent.qr_label_gen.sample_text}}"
                        placeholder="{{localService.languageContent.qr_label_gen.sample_text}}" />
                </div>
            </div>
        </div>
        <div class="dummy">
            &nbsp;
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-12" style="text-align: right;">
                <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onAction(1)">
                    {{id ? localService.languageContent.common.save : localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>